import { zodResolver } from '@hookform/resolvers/zod'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import { useForm } from 'react-hook-form'

import { AccomodationEnum } from '../../../lib/types/enums/accomodation-type/accomodation-type'
import { CenterInput } from '../../../lib/types/models/center/center-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form } from '../../elements/forms/form'
import ValidationButtons from '../../elements/validation-buttons'
import { CENTER_SCHEMA } from './center.utils'
import CenterInformationForm from './center-information-form'
import CenterJourneys from './center-journeys'

type Props = BaseFormProps<CenterInput, true> & {
  mode?: 'global-view' | 'normal-view'
  restrictedAccomodation?: AccomodationEnum
}

const CenterForm = ({
  defaultValues,
  mode = 'normal-view',
  restrictedAccomodation,
  className,
  ...validationButtonProps
}: Props) => {
  const form = useForm<CenterInput>({
    resolver: zodResolver(CENTER_SCHEMA),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        {mode === 'normal-view' ? (
          <InnerBox
            title="Informations"
            titleColor={tailwindColors.black.DEFAULT}
            className="rounded-xl"
          >
            <CenterInformationForm restrictedAccomodation={restrictedAccomodation} />
          </InnerBox>
        ) : (
          <div className={className}>
            <CenterInformationForm mode={mode} restrictedAccomodation={restrictedAccomodation} />
          </div>
        )}
        <div className="h-5" />
        {mode === 'normal-view' && <CenterJourneys />}

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default CenterForm
